import React from "react";

const EnableNotificationsModal = ({ userId, onClose }) => {
  const handleEnable = async () => {
    try {
      if (typeof Notification === "undefined") { onClose(); return; }
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        localStorage.setItem("notifPromptShown", "true");
        window.location.reload(); // recharge pour enregistrer le token FCM
      } else {
        onClose();
      }
    } catch (err) {
      console.error("Erreur lors de la demande de permission :", err);
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
      <div className="bg-white text-gray-800 p-6 rounded-2xl shadow-xl max-w-sm w-full space-y-4 animate-fadeIn">
        <h2 className="text-xl font-bold text-center">
          🔔 Restez informé(e)
        </h2>
        <p className="text-center text-sm leading-relaxed">
          Recevez en temps réel les <strong>changements de statut</strong> de vos produits,
          les <strong>promotions</strong> et les <strong>nouveautés</strong> près de chez vous.
        </p>
        <div className="flex flex-col space-y-2">
          <button
            onClick={handleEnable}
            className="bg-green-600 text-white py-2 rounded hover:bg-green-700 transition"
          >
            ✅ Activer les notifications
          </button>
          <button
            onClick={() => {
              localStorage.setItem("notifPromptShown", "true");
              onClose();
            }}
            className="text-gray-500 text-sm hover:underline"
          >
            Peut-être plus tard
          </button>
        </div>
      </div>
    </div>
  );
};

export default EnableNotificationsModal;
